import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div", ...rest }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export const MaskLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const outer = inView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { initial: "hidden", animate: "show" };
  return (
    <motion.span className="block overflow-hidden pb-[0.08em]" {...outer}>
      <motion.span
        className={`block ${className}`}
        variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const EASE_LUX = EASE;
